<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useI18n } from '@/i18n'

const { t } = useI18n()

const props = defineProps<{
  redirectUrl: string
  showMessage?: boolean // Zeige Nachricht vor Redirect (optional)
}>()

const countdown = ref(1)
const isRedirecting = ref(false)

const performRedirect = () => {
  isRedirecting.value = true
  window.location.href = props.redirectUrl
}

onMounted(() => {
  // Countdown für verzögerten Redirect
  const interval = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) {
      clearInterval(interval)
      performRedirect()
    }
  }, 100)
})
</script>

<template>
  <div class="finish-redirect has-text-centered">
    <div class="hero">
      <div class="hero-body">
        <div class="container">
          <p class="title is-3">{{ t('thankYouTitle') }}</p>
          <p class="subtitle is-5">{{ t('answersSubmitted') }}</p>

          <div class="content">
            <div v-if="!isRedirecting" class="notification">
              <p>
                {{ t('redirectingIn', { n: countdown, s: countdown !== 1 ? 's' : '' }) }}
              </p>
              <progress class="progress" :value="2 - countdown" :max="2"></progress>
            </div>
          </div>

          <div class="buttons is-centered mt-4">
            <button
              @click="performRedirect"
              class="button is-primary is-medium"
              :class="{ 'is-loading': isRedirecting }"
              :disabled="isRedirecting"
            >
              <span class="icon">
                <i class="fas fa-external-link-alt"></i>
              </span>
              <span>{{ t('redirectNow') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import '../../../assets/main.css';

.variant-compact .hero {
  padding: 1.5rem 1rem;
}

.variant-default .hero {
  padding: 2rem 1.5rem;
}

.hero {
  border-radius: 1rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.progress {
  margin-top: 1rem;
}

.notification {
  max-width: 400px;
  margin: 1.5rem auto;
}

.buttons {
  margin-top: 2rem;
}

.button.is-medium {
  padding: 1rem 2rem;
}

@media (max-width: 768px) {
  .title.is-3 {
    font-size: 1.5rem;
  }

  .subtitle.is-5 {
    font-size: 1.1rem;
  }

  .button.is-medium {
    padding: 0.75rem 1.5rem;
  }
}
</style>
